import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../customer.service';
import { CouponDTO } from '../../../../../shared/coupon-dto';
import { Subscription } from 'rxjs';

@Component({
  selector: 'pv-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit {
  code: string;
  errorMessage: string;
  coupon: CouponDTO;
  savings: number;
  redeemSubscription: Subscription;

  constructor(private customerService: CustomerService) { }

  ngOnInit() {
    this.removeCode()
  }

  redeemCode() {
    if (this.customerService.checkoutDTO.billingAddress && this.customerService.checkoutDTO.billingAddress.country_iso && this.customerService.checkoutDTO.billingAddress.zip) {
      this.coupon = null;
      this.errorMessage = null;
      if (this.code) {
        this.code = this.code.trim();

        if (this.redeemSubscription) {
          this.redeemSubscription.unsubscribe();
        }
        this.redeemSubscription = this.customerService.redeemCouponCode(this.code)
        .subscribe(([coupon, cart, discount]) => {
          this.customerService.checkoutDTO.coupon = coupon
          this.customerService.updateCheckoutDTO({ cart })

          if (coupon.couponBatch.discount_amt && !cart.couponDiscount  && coupon.couponBatch.discount_amt > cart.totalOriginal) {
            this.errorMessage = 'This coupon cannot be applied to your cart'
          } else {
            this.coupon = coupon
            this.savings = discount
          }
        }, err => {
          if (err.error.message)  {
            this.errorMessage = err.error.message
          }
          if (err.error.message.message) {
            this.errorMessage = err.error.message.message
          }
        })
      }
    }
  }

  removeCode() {
    if (this.customerService.checkoutDTO.billingAddress && this.customerService.checkoutDTO.billingAddress.country_iso && this.customerService.checkoutDTO.billingAddress.zip) {
      if (this.redeemSubscription) {
        this.redeemSubscription.unsubscribe();
      }
      this.redeemSubscription = this.customerService.redeemCouponCode('')
      .subscribe(([coupon, cart]) => this.customerService.updateCheckoutDTO({ cart }))
      this.code = null;
      this.coupon = null;
      this.errorMessage = null;
    }
  }
}
